import { CommonModule } from '@angular/common';
import { Component, EnvironmentInjector, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Select } from '@ngxs/store';
import { PublicState } from '@public/state';
import { IconCardComponent } from '@shared/components';
import { User } from '@shared/models';
import { AuthState } from '@shared/state';
import { Observable } from 'rxjs';
import {
    IonSplitPane,
    IonHeader,
    IonToolbar,
    IonApp,
    IonList,
    IonItem,
    IonLabel,
    IonIcon,
    IonRouterOutlet,
    IonMenuToggle,
    IonMenu,
} from '@ionic/angular/standalone';

@Component({
    selector: 'app-public',
    standalone: true,
    templateUrl: 'public.page.html',
    imports: [
        IonRouterOutlet,
        IonIcon,
        IonLabel,
        IonItem,
        IonList,
        IonApp,
        IonToolbar,
        IonHeader,
        IonSplitPane,
        IonMenuToggle,
        IonMenu,
        CommonModule,
        IconCardComponent,
        RouterModule,
    ],
})
export class PublicPage {
    @Select(AuthState.user) user$: Observable<User>;
    @Select(PublicState.showSplitpane) showSplitpane$: Observable<boolean>;

    environmentInjector = inject(EnvironmentInjector);

    splitPaneVisible: boolean;

    informationPages: {
        title: string;
        icon: string;
        path: string;
    }[] = [
        {
            title: 'Resor, guidningar & kurser',
            icon: 'earth-outline',
            path: '/',
        },
        {
            title: 'Snabbguide',
            icon: 'speedometer-outline',
            path: '/snabbguide',
        },
        {
            title: 'Vi på Fågelguidning',
            icon: 'accessibility-outline',
            path: '/guider',
        },
        {
            title: 'Om resor',
            icon: 'airplane-outline',
            path: '/reseinformation',
        },
        {
            title: 'Privat- & företagsguidningar',
            icon: 'chatbox-outline',
            path: '/om-guidningar',
        },
        {
            title: 'Företagsinformation',
            icon: 'information-circle-outline',
            path: '/foretags-information',
        },
        {
            title: 'Om Fågelguidning',
            icon: 'star-outline',
            path: '/om-oss',
        },
    ];

    constructor() {}

    splitPaneVisibleChanged(event: any) {
        this.splitPaneVisible = event.detail.visible;
    }
}
